import React from "react";
import { renderRoutes } from "react-router-config";

import LayoutWithMenu from "./LayoutWithMenu";

const SectionLayout = ({ route }: { route?: any }) => (
    <LayoutWithMenu route={route}>{renderRoutes(route.routes)}</LayoutWithMenu>
);

export default SectionLayout;
